export const NAV_LINKS = {
  HOME: '/',
  LOGIN: '/login',
  ABOUT: '/about',
  JOBS: '/jobs',
  JOBS_APPLIED: '/my-apps',
  BLOG: '/blog',
  PROFILE: '/profile',
  PROFILE_CREATION: '/create_profile',
};

export const APP_IDENTITY = {
  TITLE: 'KidneyWorks',
  TAGLINE: 'Empowering dialysis patients, enriching the workforce',
};
